<template>
    <div>
        <ContentHeader path-set-type="append" :gameplan-nav="false" />
        <div v-show="isMask" class="mask"></div>
        <div class="content-wrapper" v-loading='loading'>
            <el-row>
                <div class="card-top is-hover-shadow">
                    <div class="card-top-left">
                        <div class="top">
                            <span>{{themeName}}</span>
                        </div>
                        <div class="bottom">
                            <div class="left">活动PR：
                                {{prNumber}}-{{prName}}
                            </div>
                            <div class="right">{{brandName}}</div>
                        </div>
                    </div>
                    <div class="card-top-right">
                        <div class="text-time">
                            <span>活动执行时间：</span>
                            <span>{{themeStartTime}}</span>
                            <span style="margin:0 10px;">至</span>
                            <span>{{themeEndTime}}</span>
                        </div>
                    </div>
                </div>
                <div class="search">
                        <el-form :inline="true" :model="searchForm" ref="searchForm" class="searchForm" >
                        <el-form-item class="item" prop="levelBu">
                            <el-select v-model="searchForm.levelBu" placeholder="Bu" size="small" clearable>
                                <el-option
                                v-for="(key,value) in buOptions"
                                :key="value"
                                :label="getSplit(key)"
                                :value="value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item class="item" prop="levelRegion">
                            <el-select v-model="searchForm.levelRegion" placeholder="销售大区" size="small" clearable>
                                <el-option
                                v-for="(key,value) in regionOptions"
                                :key="value"
                                :label="getSplit(key)"
                                :value="value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item class="item" prop="levelCity">
                            <el-select v-model="searchForm.levelCity" placeholder="城市" size="small" clearable>
                                <el-option
                                v-for="(key,value) in cityOptions"
                                :key="value"
                                :label="getSplit(key)"
                                :value="value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item class="item" prop="channel">
                            <el-select v-model="searchForm.channel" placeholder="渠道" size="small" clearable>
                                <el-option
                                v-for="(key,value) in channelOptions"
                                :key="value"
                                :label="key"
                                :value="value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item class="item" prop="type">
                            <!-- :disabled="typeDisabled" -->
                            <el-select v-model="searchForm.type" placeholder="形式" size="small" clearable >
                                <el-option
                                v-for="(key,value) in typeOptions"
                                :key="value"
                                :label="key"
                                :value="value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item class="item" prop="level">
                            <!-- :disabled="levelDisabled" -->
                            <el-select v-model="searchForm.level" placeholder="级别" size="small" clearable >
                                <el-option
                                v-for="(key,value) in levelOptions"
                                :key="value"
                                :label="key"
                                :value="value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item class="item" prop="blockName" >
                            <!-- <el-select v-model="searchForm.blockName" placeholder="街道名称 " size="small" clearable >
                                <el-option
                                v-for="(key,value) in blockOptions"
                                :key="value"
                                :label="key"
                                :value="key">
                                </el-option>
                            </el-select> -->
                            <el-input v-model="searchForm.blockName" placeholder="街道名称 " size="small" clearable></el-input>
                        </el-form-item>
                        <el-form-item class="item-btn">
                            <el-button type="danger" size="small" @click="queryForm()">搜索</el-button>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="info" size="small" @click="resetForm()">重置</el-button>
                        </el-form-item>
                        </el-form>
                </div>
                <!-- <div class="item-select">
                    <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
                    <div class="select-btn">
                        <DialogPop
                        @confirm="disagreeAll()"
                        isType="0"
                        btnText="批量拒绝"
                        centerText="是否确认批量拒绝？"
                        >
                        </DialogPop>
                    </div>
                </div> -->
                <div class="card-item" v-for="(item) in cardData" :key="item.activityPocId">
                    <div class="card-left">
                        <!-- <div class="left-select">
                            <el-checkbox v-model="item.isChecked" @change="changeItem(item.isChecked)"></el-checkbox>
                        </div> -->
                    </div>
                    <div class="card-right">
                        <div class="top">
                            <div class="top-left" v-if=" !item.blockName">
                                <span>门店名称：</span>
                                <span>{{item.gpActivityPocDTOList[0].pocName}}</span>
                            </div>
                            <div class="top-left2" v-if=" item.blockName">
                                <div class="name-boc">
                                    <span>街区名称：</span>
                                    <span>{{item.blockName}}</span>
                                </div>
                                <div class="name-poc" v-if=" item.blockName">
                                    <span>{{getPocname(item.gpActivityPocDTOList)}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="second">
                            <span v-if="item.buName">BU:</span>
                            <span v-if="item.buName" class="center">{{getSplit(item.buName)}}</span>
                            <span v-if="item.regionName" class="line">|</span>
                            <span v-if="item.regionName">销售大区:</span>
                            <span v-if="item.regionName" class="center">{{getSplit(item.regionName)}}</span>
                            <span v-if="item.cityName" class="line">|</span>
                            <span v-if="item.cityName">City:</span>
                            <span v-if="item.cityName"  class="center">{{getSplit(item.cityName)}}</span>
                            <span v-if="item.themeChannelName" class="line">|</span>
                            <span v-if="item.themeChannelName">渠道:</span>
                            <span v-if="item.themeChannelName" class="center">{{item.themeChannelName}}</span>
                            <span v-if="item.themeStyleName" class="line">|</span>
                            <span v-if="item.themeStyleName">形式:</span>
                            <span v-if="item.themeStyleName" class="center">{{item.themeStyleName}}</span>
                            <span v-if="item.themeLevelName" class="line">|</span>
                            <span v-if="item.themeLevelName">级别:</span>
                            <span v-if="item.themeLevelName" class="center">{{item.themeLevelName}}</span>
                        </div>
                        <div v-if="item.pocReplaceMode" class="third">
                            <div class="third-left">替换类型：</div>
                            <div class="third-right">
                                <span>{{ getPocReplaceModeText(item.pocReplaceMode) }}</span>
                            </div>
                        </div>
                        <div class="third">
                            <div class="third-left">替换理由：</div>
                            <div class="third-right">
                                <span v-if="item.vendorRejectReason">{{item.vendorRejectReason}}</span>
                                <!-- <span v-if="item.exchangeReason">{{item.exchangeReason}}</span> -->
                                <span v-else>暂无理由</span>
                            </div>
                        </div>
                        <div class="last">
                            <div class="last-left"  >
                                图片凭证：
                            </div>
                            <div v-if="item.activityImageList.length > 0">
                                <div class="last-center1">
                                    <div class="item-img" v-for="i in item.activityImageList" :key="i.activityImageId">
                                        <div class="img-item">
                                            <img class="img"  @click="clickImg('/' + i.imageUri)" :src="getImg('/' + i.imageUri)" alt=""/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="last-center2" v-else>
                                <div style="color: #539EFE;height: 29px;line-height: 29px;">暂无图片凭证</div>
                            </div>
                            <div class="last-right">
                                <DialogPop
                                @confirm="agree(item)"
                                isType="1"
                                btnText="同意替换"
                                centerText="是否确认同意替换？"
                                >
                                </DialogPop>
                                <DialogPop
                                @confirm="disagree(item)"
                                isType="0"
                                btnText="拒绝替换"
                                centerText="是否确认拒绝替换？"
                                >
                                </DialogPop>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="cardData.length == 0">
                     <el-empty description="暂无数据"></el-empty>
                </div>
                <div class="pagination" v-if="cardData.length > 0">
                        <el-pagination
                        background
                        layout="total, prev, pager, next"
                        :total="searchForm.total"
                        :current-page="searchForm.page"
                        :page-size="searchForm.pageSize"
                        @current-change="handleCurrentChange"
                        />
                </div>
                <BigImg :visible="photoVisible" :url="bigImgUrl" @closeClick="()=>{photoVisible=false}">
                </BigImg>
                <div  v-show="isMask && !isEmptypoint " class="dialog">
                    <SinglePoint
                    v-if="isSinglepoint"
                    :options="igniteOptions"
                    :searchList="searchList"
                    @closeMask="closeMask"
                    @handleChange="handleChange"
                    ></SinglePoint>
                    <ManyPoint
                    v-if="isManypoint"
                    :options="igniteOptions"
                    :searchList="searchList"
                    @closeMask="closeMask"
                    @handleSelectionChange="handleSelectionChange"
                    ></ManyPoint>
                </div>
                <div  v-show="isMask && isEmptypoint" class="dialog2">
                    <EmptyPoint
                    v-if="isEmptypoint"
                    :options="igniteOptions"
                    :searchList="searchList"
                    @closeMask="closeMask"
                    @handleEmptyChange="handleEmptyChange"
                    ></EmptyPoint>
                </div>
            </el-row>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import ContentHeader from '@/components/content-header'
    import { commonUtils } from '@/utils/common'
    import DialogPop from './components/dialog-pop.vue'
    import BigImg from './components/big-img.vue'
    import SinglePoint from './components/returnChange-single-point.vue'
    import ManyPoint from './components/returnChange-many-ponit.vue'
    import EmptyPoint from './components/returnChange-empty-point.vue'
    import gameplanApi from '../../api/gameplan'
    export default {
      name: 'activityReturn-approval-detail',
      components: {
        ContentHeader,
        DialogPop,
        BigImg,
        SinglePoint,
        ManyPoint,
        EmptyPoint
      },
      data () {
        return {
            searchForm: {
                levelBu: '', // Bu
                levelRegion: '', // Region
                levelCity: '', // City
                channel: '' , // 渠道
                type: '', // 类型
                level: '', // 级别
                blockName: '',// 街道名称
                page: 1,
                pageSize: 10,
                total:0,
            },
            igniteOptions:{},
            themeId:'',
            themeStartTime:'',
            themeEndTime:'',
            themeChannels:'',
            brandName:'',
            themeName:'',
            prName: '',
            prNumber: '',
            cardData: [],
            buOptions: {},
            regionOptions:{},
            cityOptions:{},
            channelOptions:{},
            typeOptions:{},
            levelOptions:{},
            blockOptions:{},
            loading: false,
            activityId:'',
            photoVisible: false,
            bigImgUrl: "",
            typeDisabled:true,
            levelDisabled:true,
            isSinglepoint: false,
            isManypoint: false,
            isEmptypoint: false,
            isMask: false,
            agreeActivityid:'',
            searchList:{},
            checkAll: false,
            isIndeterminate: false
        }
      },
      computed: {
        ...mapGetters(['userInfo']),
      },
      watch: {
        'searchForm.channel': {
            handler (to, from) {
                if (to == '') {
                    // this.typeDisabled = true
                    this.getStyleMap()
                } else {
                    // this.typeDisabled = false
                    this.getStyleMap()
                }
            },
            deep:true,
            immediate:true
            },
        'searchForm.type': {
            handler (to, from) {
                if (to == '') {
                    // this.levelDisabled = true
                    this.getLevelMap()
                } else {
                    // this.levelDisabled = false
                    this.getLevelMap()
                }
            },
            deep:true,
            immediate:true
        },
      },
      created () {
        this.themeId = this.$route.query.themeId
        this.themeStartTime = this.$route.query.themeStartTime
        this.themeEndTime = this.$route.query.themeEndTime
        this.themeChannels = this.$route.query.themeChannels
        this.brandName = this.$route.query.brandName
        this.themeName = this.$route.query.themeName
        this.prName = this.$route.query.prName
        this.prNumber = this.$route.query.prNumber
        this.activityId = this.$route.query.activityId
        this.init()
      },
      mounted () {},
      methods: {
        init () {
            this.beginActivityreturn()
        },
        getSplit (val) {
            return val.split('|')[0]
        },
        getPocname(pocArray) {
          if (!pocArray || pocArray.length === 0) {
            return ''
          }
          const arr = []
          pocArray.map(item => {
            if (item.pocName) {
              arr.push(item.pocName)
            }
          })
          return arr.join('、');
        },
        getImg (uri) {
            return commonUtils.getImageUrl(uri)
        },
        clickImg (uri) {
            this.photoVisible = true
            this.bigImgUrl =  commonUtils.getImageUrl(uri)
        },
        handleCurrentChange (val) {
          this.searchForm.page = val
          this.getActivityreturn()
        },
        async getStyleMap () {
            let params = {
                channelCode:this.searchForm.channel
            }
            const { data } = await gameplanApi.getGameplanConfigStyleMap(params);
            if (data.resultCode === "0") {
                this.typeOptions = data.resultData.themeStyleMap || {};
            }
        },
        async getLevelMap () {
            let params = {
                styleCode:this.searchForm.type
            }
            const { data } = await gameplanApi.getGameplanConfigLevelMap(params);
            if (data.resultCode === "0") {
                this.levelOptions = data.resultData.themeLevelMap || {};
            }
        },
        async beginActivityreturn () {
            let params = {
                'page':this.searchForm.page,
                'pageSize':this.searchForm.pageSize,
                'buCode':this.searchForm.levelBu,
                'regionCode':this.searchForm.levelRegion,
                'areaCode':this.searchForm.levelCity,
                'themeChannelCode':this.searchForm.channel,
                'themeStyleCode':this.searchForm.type,
                'themeLevelCode':this.searchForm.level,
                'blockName':this.searchForm.blockName,
                // 'activityId':this.activityId,
                'themeId':this.themeId,
            }

            let res = await gameplanApi.getGamepalnActivityreturn(params);
            if (res.data.resultCode == '0') {
                let data = res.data.resultData
                this.searchForm.page = data.pageInfo.curPage
                this.searchForm.total = data.pageInfo.totalCounts
                this.buOptions = data.buCodeMap
                this.regionOptions = data.regionCodeMap
                this.cityOptions = data.areaCodeMap
                this.channelOptions = data.themeChannelCodeMap
                if (data.activityPocList !== null) {
                    let cardData = data.activityPocList
                    for (let item of cardData) {
                        item.isChecked = true
                    }
                    this.cardData = cardData
                    this.isIndeterminate = false
                    this.checkAll = true
                } else {
                    this.cardData = []
                    // this.$router.go(-1)
                }
            } else {
                console.log('接口error');
            }
        },
        // 详情搜索
        async getActivityreturn () {
            let params = {
                'page':this.searchForm.page,
                'pageSize':this.searchForm.pageSize,
                'buCode':this.searchForm.levelBu,
                'regionCode':this.searchForm.levelRegion,
                'areaCode':this.searchForm.levelCity,
                'themeChannelCode':this.searchForm.channel,
                'themeStyleCode':this.searchForm.type,
                'themeLevelCode':this.searchForm.level,
                'blockName':this.searchForm.blockName,
                // 'activityId':this.activityId,
                'themeId':this.themeId,
            }

            let res = await gameplanApi.getGamepalnActivityreturn(params);
            if (res.data.resultCode == '0') {
                let data = res.data.resultData
                this.searchForm.page = data.pageInfo.curPage
                // this.searchForm.pageSize = data.pageInfo.totalPages
                this.searchForm.total = data.pageInfo.totalCounts
                // this.buOptions = data.buCodeMap
                // this.regionOptions = data.regionCodeMap
                // this.cityOptions = data.areaCodeMap
                // this.channelOptions = data.themeChannelCodeMap
                // this.typeOptions = data.themeStyleCodeMap
                // this.levelOptions = data.themeLevelCodeMap
                // this.blockOptions = data.blockNameSet
                if (data.activityPocList !== null) {
                    let cardData = data.activityPocList
                    for (let item of cardData) {
                        item.isChecked = true
                    }
                    this.cardData = cardData
                    this.isIndeterminate = false
                    this.checkAll = true
                } else {
                    this.cardData = []
                    // this.$router.go(-1)
                }
            } else {
                console.log('接口error');
            }
        },
        gamepalnActivityapprove (params) {
            gameplanApi.getGamepalnActivityapprove(params).then(res=>{
                if (res.data.resultCode === '0') {
                    this.loading = false
                    if (params.activityInfoVOList[0].gpActivityInfoDTO.processAction == '02') {
                        this.$message.success('售点替换审批通过成功');
                        // this.$router.go(-1)
                    } else if (params.activityInfoVOList[0].gpActivityInfoDTO.processAction == '03') {
                        this.$message.success('售点替换审批拒绝成功');
                        // this.$router.go(-1)
                    }
                    this.getActivityreturn()
                } else {
                    console.log('error');
                    this.loading = false
                }
            })
        },
        // 售点替换审批
        saleUpadateapproval (params) {
            this.loading = true
            gameplanApi.saleUpadateapproval(params).then(res=>{
                if (res.data.resultCode === '0') {
                    this.loading = false
                    if (params.processAction == '02') {
                        this.$message.success('售点替换审批通过成功');
                    } else if (params.processAction == '03') {
                        this.$message.success('售点替换审批拒绝成功');
                    }
                    this.getActivityreturn()
                } else {
                    console.log('error');
                    this.loading = false
                }
            })
        },
        // 售点批量退回审批
        batchRejectapproval (params) {
            this.loading = true
            gameplanApi.batchRejectapproval(params).then(res=>{
                if (res.data.resultCode === '0') {
                    this.loading = false
                    this.$message.success('售点批量退回审批成功');
                    this.$router.go(-1)
                } else {
                    console.log('error');
                    this.loading = false
                }
            })
        },
        // 搜索
        queryForm (val) {
            this.$refs.searchForm.validate((valid) => {
                if (valid) {
                    this.searchForm.page = 1
                    this.getActivityreturn()
                } else {
                    console.log('error submit!!');
                }
            });
        },
        // 重置
        resetForm () {
            this.$refs.searchForm.resetFields();
            this.searchForm.page = 1
            this.getActivityreturn()
        },
        // 同意
        agree (item) {
            // console.log(item.gpThemeDetailDTO.pocRelateType,'agree');
            // console.log(item,'agree');
            let params ={
                'activityInfoVOList':
                [
                    {'gpActivityInfoDTO':
                        {
                            'processType': '05',
                            'processAction': '02',
                            'activityId': item.activityId
                        }
                    }
                ]
            }
            this.loading = true
            this.gamepalnActivityapprove(params)

            // if (item.gpThemeDetailDTO.pocRelateType == '0') {
            //     this.isEmptypoint = true
            // } else if (item.gpThemeDetailDTO.pocRelateType == '1') {
            //     this.isSinglepoint = true
            // } else if (item.gpThemeDetailDTO.pocRelateType == '2') {
            //     this.isManypoint = true
            // }
            // this.searchList.regionCode = item.regionCode
            // this.searchList.pocCountMin = item.gpThemeDetailDTO.pocCountMin
            // this.searchList.themeDetailId = item.themeDetailId
            // this.searchList.blockName = item.blockName
            // if (this.isSinglepoint) {
            //     let reviseObj = {
            //         'selectList':item.gpActivityPocDTOList,
            //         'foodStreet':item.blockName,
            //         'bwContactPerson':item.bwContactPerson,
            //         'areaCode':item.areaCode,
            //         // 'timeList':row.timeList
            //     }
            //     this.searchList.reviseObj = reviseObj
            //     this.searchList.igniteRuleObj = item.igniteRuleDTOList[0].igniteRuleObj
            // } else if (this.isManypoint) {
            //     let reviseObj = {
            //         'selectList':item.gpActivityPocDTOList,
            //         'foodStreet':item.blockName,
            //         'bwContactPerson':item.bwContactPerson,
            //         'areaCode':item.areaCode,
            //         // 'timeList':row.timeList
            //     }
            //     this.searchList.reviseObj = reviseObj
            //     this.searchList.igniteRuleObj = item.igniteRuleDTOList[0].igniteRuleObj
            // } else if (this.isEmptypoint){
            //     let reviseObj = {
            //         'selectList':item.gpActivityPocDTOList,
            //         'foodStreet':item.blockName,
            //         'bwContactPerson':item.bwContactPerson,
            //         'areaCode':item.areaCode,
            //         'blockAddress':item.blockAddress,
            //         'areaName':item.areaName
            //         // 'timeList':row.timeList
            //     }
            //     this.searchList.reviseObj = reviseObj
            // }
            // console.log(item,'item-agree');
            // console.log(this.searchList,'item-agree-searchList');

            // this.isMask = true
            // this.agreeActivityid = item.activityId
        },
        // 拒绝
        disagree (item) {
            let params ={
                'activityInfoVOList':
                [
                    {'gpActivityInfoDTO':
                        {
                            'processType': '05',
                            'processAction': '03',
                            'activityId': item.activityId
                        }
                    }
                ]
            }
            this.loading = true
            this.gamepalnActivityapprove(params)
            // let params = {
            //     'processAction': '03',
            //     'activityId': item.activityId
            // }
            // this.saleUpadateapproval(params)
        },
        // 批量拒绝
        disagreeAll () {
            let arr =[]
            for (const item of this.cardData) {
                if (item.isChecked) {
                    arr.push({
                        'activityId':item.activityId,
                        'processAction': '03'
                    })
                }
            }
            this.batchRejectapproval(arr)
            console.log(arr,'arr');
        },
        closeMask () {
            this.isMask = false
            this.isSinglepoint = false
            this.isManypoint = false
            this.isEmptypoint = false
            this.agreeActivityid = ''
        },
        handleChange (val) {
            console.log(val,'单售点');
            let arr = []
            for (let item of val) {
                arr.push({
                    "cityName": item.cityName,
                    "contactPerson": item.contactPerson,
                    "contactPhone": item.contactPhone,
                    "igniteId": item.igniteId,
                    "pocAddress": item.pocAddress,
                    "pocName": item.pocName,
                    "pocPoiId": item.pocPoiId,
                    "provinceName": item.provinceName,
                    "locLongitude":item.locLongitude,
                    "locLatitude":item.locLatitude,
                    'pocDetail':item.pocDetail
                })
            }
            let params = {
                'processAction': '02',
                'activityId':this.agreeActivityid,
                'gpActivityPocDTOList':arr
            }
            console.log(params,'单售点-params');
            // this.saleUpadateapproval(params)
        },
        handleSelectionChange (val) {
            console.log(val,'多售点');
            let arr = []
            for (let item of val) {
                arr.push({
                    "cityName": item.cityName,
                    "contactPerson": item.contactPerson,
                    "contactPhone": item.contactPhone,
                    "igniteId": item.igniteId,
                    "pocAddress": item.pocAddress,
                    "pocName": item.pocName,
                    "pocPoiId": item.pocPoiId,
                    "provinceName": item.provinceName,
                    "locLongitude":item.locLongitude,
                    "locLatitude":item.locLatitude,
                    'pocDetail':item.pocDetail
                })
            }
            let params = {
                'processAction': '02',
                'activityId':this.agreeActivityid,
                'gpActivityPocDTOList':arr,
                'blockName':val[0].block_name
            }
            // this.saleUpadateapproval(params)
            console.log(params,'多售点-params');
        },
        handleEmptyChange (val){
            console.log(val,'无售点');
            // 未测试
            let params = {
                'processAction': '02',
                'activityId':this.agreeActivityid,
                'gpActivityPocDTOList':[],
                'blockName':val[0].block_name
            }
            console.log(params,'无售点-params');
            // this.saleUpadateapproval(params)
        },
        //单选
        changeItem (item) {
            console.log(item,'单选');
            // isShowsome 未全选  isShowall 全选  isShownone 全不选
            let isShowsome =  this.cardData.some(item=>{
                return item.isChecked == false
            })
            let isShowall =  this.cardData.every(item=>{
                return item.isChecked == true
            })
            let isShownone =  this.cardData.every(item=>{
                return item.isChecked == false
            })
            if (isShowall) {
                this.isIndeterminate = false
                this.checkAll = true
            } else if(isShownone) {
                this.isIndeterminate = false
                this.checkAll = false
            } else if(isShowsome) {
                this.isIndeterminate = true
                this.checkAll = false
            }
        },
        //全选
        handleCheckAllChange () {
            // isHavefasle 判断是否有至少一个勾选 isShowsome 未全选  isShowall 全选  isShownone 全不选
            let isHavefasle =  this.cardData.some(item=>{
                return item.isChecked == false
            })
            if (isHavefasle) {
                for (let item of this.cardData) {
                    item.isChecked = true
                }
            } else {
                for (let item of this.cardData) {
                    item.isChecked = !item.isChecked
                }
            }
            let isShowsome =  this.cardData.some(item=>{
                return item.isChecked == false
            })
            let isShowall =  this.cardData.every(item=>{
                return item.isChecked == true
            })
            let isShownone =  this.cardData.every(item=>{
                return item.isChecked == false
            })
            if (isShowall) {
                this.isIndeterminate = false
                this.checkAll = true
            } else if(isShownone) {
                this.isIndeterminate = false
                this.checkAll = false
            } else if(isShowsome) {
                this.isIndeterminate = true
                this.checkAll = false
            }
        },
        getPocReplaceModeText(val) {
          if (val === '01') {
            return '替换售点'
          } else if (val === '02') {
            return '替换街区'
          } else {
            return ''
          }
        }
      }
    }
</script>
<style lang="scss" scoped>
    .is-hover-shadow:hover {
    box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.2);
    }
    .mask{
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background: rgba(0,0,0,.7) ;
        z-index: 3;
    }
    .dialog {
        position: fixed;
        top: 5%;
        left: calc((100vw - 1000px)/2);
        width: 1000px;
        padding: 20px;
        background-color: #FFFFFF;
        border-radius: 10px;
        z-index: 3;
    }
    .dialog2 {
        position: fixed;
        top: 25%;
        left: calc((100vw - 600px)/2);
        width: 600px;
        // height: 300px;
        padding: 20px;
        background-color: #FFFFFF;
        border-radius: 10px;
        z-index: 3;
    }
    .content-wrapper {
      min-height: calc(100vh - 320px) !important;
      font-family: SourceHanSansSC-regular;
      .card-top {
        line-height: 20px;
        border-radius: 10px;
        padding: 10px 20px;
        margin-bottom: 30px;
        font-size: 14px;
        text-align: center;
        background-color: #FFFFFF;
        color: #101010;
        font-family: Roboto;
        display: flex;
        justify-content: flex-start;
        .card-top-left {
            flex: 1;
            .top {
                line-height: 29px;
                color: #101010;
                font-size: 20px;
                font-weight: 600;
                text-align: left;
                margin-bottom: 5px;
                word-wrap: break-word;
                word-break: normal;
                word-break: break-all;
            }
            .bottom {
                display: flex;
                justify-content: flex-start;
                .left {
                    font-size: 16px;
                    margin-right: 11px;
                    line-height: 24px;
                }
                .right {
                    line-height: 14px;
                    padding: 3px 10px;
                    margin-top: 2px;
                    border-radius: 4px;
                    font-size: 14px;
                    background-color: #FFFFFF;
                    color: #539EFE;
                    border: 1px solid #539EFE;
                    text-align: center;
                }
            }
        }
        .card-top-right {
            width: 30%;
            text-align: right;
            line-height: 20px;
            margin-top: 40px;
            color: #999999;
        }
    }
      .search {
        .searchForm {
            width: 100%;
            .item {
                width:121px;
            }
            .item-btn {
                margin-left: 150px;
            }
        }
    }
    .item-select {
        line-height: 30px;
        height: 30px;
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
        ::v-deep .el-checkbox__input.is-checked+.el-checkbox__label {
            color: #cd1231;
        }
        .select-btn {
            display: flex;
            margin: auto;
            margin-right: 10px;
        }

    }
    .card-item {
        border-radius: 10px;
        padding: 10px 20px;
        margin-bottom: 30px;
        font-size: 14px;
        text-align: left;
        background-color: #FFFFFF;
        color: #101010;
        // font-family: Roboto;
        display: flex;
        .card-left {
            .left-select {
                margin-top: 6px;
                margin-right: 5px;
            }
        }
        .card-right {
            flex: 1;
            .top {
                display: flex;
                .top-left {
                    color: #101010;
                    font-size: 16px;
                    font-weight: 600;
                    margin-right: 10px;
                    line-height: 29px;
                    word-wrap: break-word;
                    word-break: normal;
                    word-break: break-all;
                }
                .top-left2 {
                    text-align: left;
                    .name-boc {
                        font-size: 16px;
                        font-weight: 600;
                        color: #101010;
                        line-height: 29px;
                        word-wrap: break-word;
                        word-break: normal;
                        word-break: break-all;
                    }
                    .name-poc {
                        font-size: 14px;
                        color: #cd1231;
                        line-height: 29px;
                        word-wrap: break-word;
                        word-break: normal;
                        word-break: break-all;
                    }
                }
                .top-right {
                    padding: 2px 5px;
                    height: 19px;
                    line-height: 19px;
                    margin-top: 3px;
                    border-radius: 4px;
                    background-color: rgba(255, 255, 255, 1);
                    color: rgba(205, 18, 49, 1);
                    font-size: 14px;
                    text-align: center;
                    font-family: Microsoft Yahei;
                    border: 1px solid rgba(205, 18, 49, 1);
                }
            }
            .second {
                display: flex;
                line-height: 29px;
                color: rgba(16, 16, 16, 1);
                font-size: 14px;
                text-align: left;
                .center {
                    margin-left: 10px;
                }
                .line {
                    margin: 0 10px;
                }
            }
            .third {
                display: flex;
                color: #539EFE;
                .third-left {
                    line-height: 29px;
                }
                .third-right {
                    flex: 1;
                    line-height: 29px;
                    word-wrap: break-word;
                    word-break: normal;
                    word-break: break-all;
                }
            }
            .last {
                display: flex;
                line-height: 29px;
                .last-left {
                    color: #539EFE;
                    line-height: 29px;
                }
                .last-center1 {
                    display: flex;
                    flex-wrap: wrap;
                    .item-img {
                        .img-item {
                            margin-right: 5px;
                            margin-bottom: 5px;
                            width: 64px;
                            cursor: pointer;
                            overflow:hidden;
                            max-height: 64px;
                            .img {
                                width:100%;
                                height:100%;
                                background-position:center center;
                                background-repeat: no-repeat;
                                -webkit-background-size:cover;
                                -moz-background-size:cover;
                                background-size:cover;
                            }
                        }
                    }
                }
                .last-center2 {
                    display: flex;
                    flex: 1;
                }
                .last-right {
                    // height: 29px;
                    margin-top: 18px;
                    line-height: 29px;
                    flex: 1;
                    display: flex;
                    justify-content: flex-end;
                    font-size: 14px;
                    text-align: center;
                }
            }
        }
    }
    .pagination {
        position: relative;
        bottom: 0;
        text-align: center;
    }
    }
</style>
